import { MissionBox } from '@/app/components/container/mission-box';
import { ProtectedBox } from '@/app/components/container/protected-box';
import {
  ConversationActivityListingPage,
  KnowledgeActivityListingPage,
  LLMActivityListingPage,
  MonitoringPage,
  STTActivityListingPage,
  ToolActivityListingPage,
  TTSActivityListingPage,
  WebhookActivityListingPage,
} from '@/app/pages/activities';
import { Routes, Route, Outlet } from 'react-router-dom';
import { CONFIG } from '@/configs';

export function ObservabilityRoute() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedBox>
            <MissionBox>
              <Outlet />
            </MissionBox>
          </ProtectedBox>
        }
      >
        <Route index key="logs" path="/" element={<LLMActivityListingPage />} />
        <Route
          key="monitoring"
          path="/monitoring"
          element={<MonitoringPage />}
        />
        <Route
          key="webhook-logs"
          path="/webhook"
          element={<WebhookActivityListingPage />}
        />
        {CONFIG.workspace.features?.knowledge !== false && (
          <Route
            key="knowledge-logs"
            path="/knowledge"
            element={<KnowledgeActivityListingPage />}
          />
        )}
        <Route
          key="tool-logs"
          path="/tool"
          element={<ToolActivityListingPage />}
        />
        <Route
          key="stt-logs"
          path="/stt"
          element={<STTActivityListingPage />}
        />
        <Route
          key="tts-logs"
          path="/tts"
          element={<TTSActivityListingPage />}
        />
        <Route
          key="conversation-logs"
          path="/conversation"
          element={<ConversationActivityListingPage />}
        />
      </Route>
    </Routes>
  );
}
